import { Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { iAppInfo } from '../interfaces/app-info';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { StorageService } from './storage.service';
import { AlertController, isPlatform } from '@ionic/angular';


@Injectable({
	providedIn: 'root'
})
export class AppService {

	// Default app info used initial and as fallback
	public appInfo: iAppInfo = {
		contact_mail: 'info@arcticexcursions.com',
		contact_phone: '+299 34 85 89',
		info_message: '',
		languages: [
			'da',
		],
		version: '0.0.0',
		website_url: 'https://arcticexcursions.com'
	}

	public dateTimePickerToolTip: string = 'Klik på mdr og år i toppen, for hurtigt at vælge ny mdr. eller årstal. Afslut valget ved at trykke på mdr. og år igen. Vælg dato og tryk "Gem".'

	// If the api endpoint should differ from the environment variable, it can be set here
	public apiEndpointOverride: string = ''
	public isGRB: WritableSignal<boolean> = signal(false);
	public isDev: WritableSignal<boolean> = signal(false);


	constructor(
		private http: HttpClient,
		private storage: StorageService,
		private alertController: AlertController
	) {
		this.isGRB.set(isPlatform('desktop'))
	}


	/**
	 * Gets either enviorment or override api endpoint - either from storage or local
	 *
	 * @returns
	 **/
	public getApiEndpoint() {

		// Check for api override local and in storage if not already set
		if(this.apiEndpointOverride !== 'none') {
			if(this.apiEndpointOverride !== '') {
				return this.apiEndpointOverride
			}
			else {
				// Get api endpoint from storage
				this.storage.get('api-override').then((api_endpoint) => {
					if(api_endpoint) {
						this.isDev.set(true)
						this.apiEndpointOverride = api_endpoint
						return this.apiEndpointOverride
					}
					else {
						// Flag "none" to prevent checking storage again
						this.isDev.set(false)
						this.apiEndpointOverride = 'none'
						return environment.api_endpoint
					}
				})
			}
		}

		// Return default api endpoint
		return environment.api_endpoint
	}


	/**
	 * Gets app info
	 * 
	 * @returns 
	 */
	public getAppInfo() {
		const url = this.getApiEndpoint() + '/wp-json/arctic_excursions/app-info'
		const body = new HttpParams().set('version', environment.app_version)
		const headers = {
			headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
		}

		return this.http.post(url, body.toString(), headers)
	}


	/**
	 * Format a date-object to the designs format - Used on birthdays
	 * 
	 * @param date 
	 * @returns 
	 */
	public formatDate(date: Date, format: 'dmy' | 'full' = 'full'): string {
		if (!date || isNaN(date.getTime())) {
			return 'Ingen dato';
		}

		const options: Intl.DateTimeFormatOptions = format === 'dmy' 
			? { day: '2-digit', month: '2-digit', year: 'numeric' }
			: { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };

		return new Intl.DateTimeFormat('en-GB', options).format(date).replace(', ', ' ');
	}


	/**
	 * Set api endpoint override url and dev mode
	 **/
	public setApiEndpointOverride(endpoint: string, isDev: boolean = true) {
		this.apiEndpointOverride = endpoint
		this.appInfo.api_endpoint = endpoint
		this.storage.set('api-override', endpoint)
		this.isDev.set(isDev)
	}


	/**
	 * Pop a simple message to the user
	 **/
	public async popMessage(header: string, message: string, buttons: string[] = ['Luk']) {
		const alert = await this.alertController.create({
			header: header,
			message: message,
			buttons: buttons
		})

		await alert.present()
	}
}
